// extracted by mini-css-extract-plugin
export var deleteIcon = "_qc-5";
export var deleteOption = "_qc-3";
export var divider = "_qc-2";
export var downloadIcon = "_qc-4";
export var drawer = "_qc-0";
export var drawerFooter = "_qc-6";
export var drawerOpen = "_qc-1";
export var highlighted = "_qc-7";
export var lighterHighlight = "_qc-8";